import { AnyAction } from "redux";
import { Dispatch } from "react";
import { CommonsRaw, Result, } from "../../../../interfaces";
import { Create } from "../../../commons";
import { Adapter } from "../../../../shared/adapter";
import { SearchersAdapter } from "../../../../adapter/searchers-adapter";

export const FETCH_CREATE_COMMONS_REQUEST = 'FETCH_COMMONS_REQUEST';
export const FETCH_CREATE_COMMONS_SUCCESS = 'FETCH_COMMONS_SUCCESS';
export const FETCH_CREATE_COMMONS_FAILURE = 'FETCH_COMMONS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateCommonsRequest = () => {
    return {
        type: FETCH_CREATE_COMMONS_REQUEST,
    };
};

const fetchCreateCommonsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_COMMONS_SUCCESS,
        payload: data
    };
};

const fetchCreateCommonsFailure = (error: any) => {
    return {
        type: FETCH_CREATE_COMMONS_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (commons:CommonsRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateCommonsRequest());
        try {
            const response = await Create(commons);
            dispatch(fetchCreateCommonsSuccess(
                Adapter.from(response.data).to((value) => new SearchersAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateCommonsFailure(error.message));
        }
    };
};